import {Component} from "@angular/core";
import {CognitoCallback} from "../../../providers/cognito.service";
import {AlertController, NavController} from "ionic-angular";
import {ForgotPasswordStep2Component} from "./forgotPassword2.component";
import {UserLoginService} from "../../../providers/userLogin.service";
import {RegisterComponent} from "../register/register.component";
import {LoginComponent} from "../login/login.component";
import { Router } from '@angular/router';

@Component({
    templateUrl: 'forgotPassword.html',
    selector: 'forgot-password-page ',
})
export class ForgotPasswordStep1Component implements CognitoCallback {
    email: string;

    constructor(
      public nav: NavController, 
      public alertCtrl: AlertController, 
      public userService: UserLoginService,
      private router: Router
      ) {
    }

    onNext() {
        this.userService.forgotPassword(this.email, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message == null && result == null) { //success
            this.nav.push(ForgotPasswordStep2Component, {'email': this.email});
            this.router.navigate(['/createPW']);
            this.doAlert("Password Reset Successful!", "A temporary verification code has been sent to your email address. <br><br> Use that verification code below, and you will be able to create a new password for your account.");
        } else { //error
            console.log("messagemessagemessage", message)
            message=(message==="Username/client id combination not found.")?"We're sorry, we were unable to find that account.":message;
            let title=(message==="Username/client id combination not found.")?"User Not Found!":"Reset Password";
            message=(message==="User password cannot be reset in the current state.")?"User must activate their account with the login password provided to them in their activation email before resetting their password. Please contact logitsupport@consultaegis.com if this problem persists.":message;
            title=(message==="User password cannot be reset in the current state.")?"User Not Ready For Reset!":title;


             this.doAlert(title, message);

        }
    }

    navToRegister() {
        this.nav.push(RegisterComponent);
    }

    navToLogin() {
        this.nav.push(LoginComponent);
        this.router.navigate(['/login']);
    }

    doAlert(title: string, message: string) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/auth/forgot-password/forgotPassword1.component.ts